import { addSuffixToValue, autoCapitalizeText, formatValue, removeMarkdownKeepTrailingSpace, } from "./format";
import { precision, isDecimal } from "./number";
export const removeLeadingZeroFromNumber = (value) => {
    const str = String(value).replace(/^0+/, "0");
    if (String(str).length === 1) {
        return str;
    }
    /* eslint-disable no-useless-escape */
    return String(str).replace(/^0+(?![.|,])/, "");
};
export const formatFieldValue = (value, { type, name, suffix, capitalize, format, fractionalDigits, }) => {
    if (format) {
        const formatted = formatValue(removeMarkdownKeepTrailingSpace(value), format);
        if (formatted === false)
            return false; // preserve original behavior
        return autoCapitalizeText(formatted, type, capitalize);
    }
    if (type === "number" || fractionalDigits) {
        return removeLeadingZeroFromNumber(removeMarkdownKeepTrailingSpace(value));
    }
    if (type === "password" || name.toLowerCase().includes("password")) {
        return value;
    }
    if (type === "email") {
        return value;
    }
    if (type === "document_path") {
        return addSuffixToValue(value, suffix);
    }
    return autoCapitalizeText(removeMarkdownKeepTrailingSpace(value), type, capitalize);
};
export const isValueFilled = (value) => value || value === 0;
const shouldFormatDigits = (fractionalDigits, value) => {
    if (isDecimal(value)) {
        return fractionalDigits && precision(value) > fractionalDigits;
    }
    else {
        return false;
    }
};
export const processValue = (fractionalDigits, value) => {
    if (shouldFormatDigits(fractionalDigits, value)) {
        return Number(value).toFixed(fractionalDigits);
    }
    return value;
};
